import { render, staticRenderFns } from "./header-sys.vue?vue&type=template&id=fba06be4&scoped=true&"
import script from "./header-sys.vue?vue&type=script&lang=js&"
export * from "./header-sys.vue?vue&type=script&lang=js&"
import style0 from "./header-sys.vue?vue&type=style&index=0&id=fba06be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba06be4",
  null
  
)

export default component.exports